import { useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

/**
 * Google OAuth Callback Handler
 * This component receives the OAuth callback from Google and forwards it to the backend
 * The backend then validates the code and sets the session cookie
 */
function GoogleCallback() {
  useEffect(() => {
    // Forward the entire URL (including query params) to the backend
    // The backend will handle the OAuth code exchange
    const currentUrl = window.location.href;
    const backendCallbackUrl = currentUrl.replace(window.location.origin, BACKEND_URL);
    
    // Redirect to backend to complete OAuth flow
    window.location.href = backendCallbackUrl;
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Completing Google sign-in...</p>
      </div>
    </div>
  );
}

export default GoogleCallback;
